import React, { FC } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./cardIconStyle";

interface IProps {
  className: string;
  color: "warning" | "success" | "danger" | "info" | "primary" | "rose";
}
// @ts-ignore
const useStyles = makeStyles(styles);

export const CardIcon: FC<IProps> = props => {
  const classes = useStyles();
  const { className, children, color, ...rest } = props;
  const cardIconClasses = classNames({
    [classes.cardIcon]: true,
    //@ts-ignore
    [classes[color + "CardHeader"]]: color,
    [className]: className !== undefined
  });
  return (
    <div className={cardIconClasses} {...rest}>
      {children}
    </div>
  );
};
